module.exports = __webpack_public_path__ + "img/project-23.5c1f6599.png";